var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 946,
    height: 1081,
    fill: "none",
    viewBox: "0 0 946 1081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.568
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.212,
    cy: 540.543,
    fill: "url(#paint0_linear)",
    rx: 271.2,
    ry: 176.822,
    transform: "rotate(-36 376.212 540.543)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.424
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B62ACF",
    fillRule: "evenodd",
    d: "M342.08 723.864l60.039-55.541 32.793-129.488-11.806-57.499 12.543-40.018-85.445 45.585-23.548 69.64-4.378 59.639 19.802 107.682z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial)",
    fillRule: "evenodd",
    d: "M171.122 689.549c75.195-90.451 201.648 65.604 259.79-110.134 58.142-175.738 62.565-246.174 138.608-234.2 76.042 11.975 202.791 54.3 202.791 54.3L678.76 721.087 394.326 996.764S95.927 780.001 171.122 689.549z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 1138.06,
    height: 1080.76,
    x: -192.817,
    y: 0.164,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 163.097
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 361.279,
    height: 530.453,
    x: 198.324,
    y: 317.364,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 61.977
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(20.279 -1546.988 1440.936) scale(264.218 343.719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 105.012,
    x2: 105.012,
    y1: 363.721,
    y2: 717.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B88FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F30EC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.a72e980c90b10ae4370806451003212a.svg";
export { ForwardRef as ReactComponent };